<div class="container">
    <div class="wrapper">
        <h2 class="title">{{ blog().title }}</h2>
        <p [innerHTML]="blog().body | html" class="mt-4 mb-16"></p>

        @if (authors().length > 0) {
            <h3 class="mt-8" i18n>Written by</h3>
            @for (author of authors(); track $index) {
                <ng-container *ngTemplateOutlet="authorTemplate; context: { author }"></ng-container>
            }
        }
    </div>
</div>

<ng-template #authorTemplate let-author="author">
    <div class="flex items-center mb-3 mt-3">
        <img style="max-width: 65px; margin-inline-end: 1rem" placeholder [ngSrc]="author.image" width="256" height="256" alt="{{ author.name }}" />
        <div class="flex flex-col">
            <h4 style="margin-top: 0">{{ author.name }}</h4>
            @if (author.bio) {
                <span>{{ author.bio }}</span>
            }
        </div>
    </div>
</ng-template>
